import React, { memo, useMemo } from 'react';
import { Box } from '@mui/material';
import { extractYouTubeId } from '../../../../utils/extractYouTubeId';

interface MemoizedYouTubePreviewProps {
  videoUrl: string;
}

export const MemoizedYouTubePreview = memo<MemoizedYouTubePreviewProps>(({ videoUrl }) => {
  const embedUrl = useMemo(() => {
    const videoId = extractYouTubeId(videoUrl);
    return videoId ? `https://www.youtube.com/embed/${videoId}` : null;
  }, [videoUrl]);

  if (!embedUrl) {
    return null;
  }

  return (
    <Box sx={{ mt: 2 }}>
      <iframe
        width="50%"
        height="100"
        src={embedUrl}
        title="YouTube video preview"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </Box>
  );
}, (prevProps, nextProps) => {
  // Só re-renderiza se a URL mudar
  return prevProps.videoUrl === nextProps.videoUrl;
});

MemoizedYouTubePreview.displayName = 'MemoizedYouTubePreview';

